import { __assign, __awaiter, __extends, __generator } from "tslib";
import BaseRepository from '@/core/standard/BaseRepository';
import { axiosInstance } from '@/setup/axios/AxiosConfig';

var TableServices =
/** @class */
function (_super) {
  __extends(TableServices, _super);

  function TableServices() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.collection = 'tables';
    _this.version = 'v1';
    return _this;
  }

  TableServices.prototype.getTableStyles = function (params) {
    return this.request(__assign(__assign({}, params), {
      method: 'GET',
      url: 'table_styles'
    }));
  };

  TableServices.prototype.createTableStyles = function (params) {
    return this.request(__assign(__assign({}, params), {
      method: 'POST',
      url: 'table_styles'
    }));
  };

  TableServices.prototype.updateTableStyles = function (params) {
    return this.request(__assign(__assign({}, params), {
      method: 'PUT',
      url: 'table_styles'
    }));
  };

  TableServices.prototype.deleteAllStyles = function (params) {
    return this.request(__assign(__assign({}, params), {
      method: 'POST',
      url: 'table_styles/delete_all_styles'
    }));
  };

  TableServices.prototype.deleteTableStyles = function (params) {
    return this.request(__assign(__assign({}, params), {
      method: 'DELETE',
      url: 'table_styles'
    }));
  };

  TableServices.prototype.getTablesListByLocal = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.request(__assign(__assign({}, params), {
          url: 'list_bar'
        }))];
      });
    });
  };

  return TableServices;
}(BaseRepository);

export default new TableServices(axiosInstance);